import { CartAddressInput, ShippingCartAddress } from '_app/types/api'

export enum STEPS {
  DELIVERY,
  PAYMENT,
  SUMMARY,
}

export interface Location {
  longitude: number;
  latitude: number;
}

export interface Address {
  line1: string;
  line2: string;
}

export interface AddressDetails {
  city: string;
  province: string;
  post_code: string;
  street: string;
  building_number: string;
  flat_number: string;
}

export interface Point {
  name: string;
  type: string[];
  location: Location;
  location_date?: any;
  location_description: string;
  opening_hours: string;
  address: Address;
  address_details: AddressDetails;
  functions: string[];
  partner_id: number;
  apm_doubled?: any;
  location_247: boolean;
  image_url: string;
  easy_access_zone: boolean;
}

export type Modal = { closeModal: () => void };

export type AddressFormData = {
  email: string | undefined;
  billing_address: {
    is_invoice: 'business' | 'person';
    invoice_type: 'company' | 'individual';
  } & Partial<CartAddressInput>;
  shipping_address: ShippingCartAddress & {
    country_code: string;
    region_id?: number;
  };
  receive_invoice: boolean;
  accept_regulations: boolean;
  subscribe_to_newsletter_email: boolean;
  send_receipt_to_different_address: boolean;
};
